<app-header bannerImage="horizon-sprayer.png"></app-header>
<div class="generalInformation">
  <div *ngIf="showIntroduction && !results" id="introduction">
    <p i18n="@@landingPagePara1">
      Tankmix is a service outlining the mixability of YaraVita&trade;
      products with many plant protection products.
    </p>
    <p i18n="@@landingPagePara2">
      Access is freely available to everyone, and allows for better
      planning of spray programmes and spraying opportunities with
      most of the YaraVita™ range. Each tank mix test is carried out under controlled conditions in our product
      development laboratories following BS EN ISO 9001:2000
      guidelines and represents a fair measure of the performance of each mixture made.
      Of course, there are many variables in making tank mixes under field conditions that
      can influence the mixability of any mixture made and so the Tankmix is just a guide and not a
      guarantee of either physical or biological compatibility.
    </p>


    <h4 i18n="@@titleIntroToSeedCoating">
      New! Enhanced Services for Seed Coatings
    </h4>
    <p i18n="@@introToSeedCoatingPara1">
      Yara products applied as seed coatings have proved to be a important way
      of enhancing the value of seeds. Due to the surge of interest, we
      have added the seed treatment product development process to this website.
      It is now quick and easy to get a potential seed coating developed and
      tested.
      <a [routerLink]="['/request-seed-treatment']">Find out more </a>
    </p>
  </div>
  <button class="btn" (click)="toggleIntroduction()" i18n="@@ShowHide">
    Show/Hide Introduction
  </button>

</div>

<div *ngIf="!results">
  <h2 i18n="@@Search">Search</h2>
  <form *ngIf="!searching" [formGroup]="searchForm">
    <div class="sideBySide">
      <!-- LEFT COLUMN -->
      <div>
        <div *ngIf="countryChoices" class="form-group">
          <label for="countryDropDown" i18n="@@Select your country">Select your country</label>
          <select id="countryDropDown"
                  required
                  name="countryDropDown"
                  formControlName="countryCode"
                  autocomplete="country-name"
                  (change)="changeCountry()">
            <option *ngFor="let choice of countryChoices" [value]="choice.id">
              {{ choice.name }}
            </option>
          </select>
          <!-- <small *ngIf="!countryChosen" class="form-text textmuted error" i18n="@@Required">Required</small> -->
        </div>

        <div class="form-group">
          <label for="yaraChemicalId" i18n="@@Choose a Yara Product (optional)">
            Choose a Yara Product (optional)
          </label>
          <div class="input-block">
            <app-nameid-typeahead [items]="yaraProductChoices"
                                  id="yaraChemicalId"
                                  formControlName="yaraChemicalId">
            </app-nameid-typeahead>
          </div>
        </div>
      </div>

      <!-- RIGHT COLUMN -->
      <div>
        <div class="form-group">
          <label i18n="@@ProductAgro">Yara Product or Agrochemical</label>
          <div class="input-block">
            <app-nameid-typeahead [items]="agrochemicalChoices"
                                  id="agrochemicalCode"
                                  formControlName="agrochemicalCode">
            </app-nameid-typeahead>
          </div>
        </div>

        <div class="form-group">
          <label for="activeIngredientDropDown" i18n="@@Choose an Active Ingredient (optional)">
            Choose an Active Ingredient (optional)
          </label>
          <div class="input-block">
            <app-nameid-typeahead [items]="activeIngredientChoices"
                                  formControlName="activeIngredientCode">
            </app-nameid-typeahead>
          </div>
        </div>
      </div>
    </div>

    <br />

    <div *ngIf="countryChosen" class="actions">
      <button id="searchForTankmixes" class="btn btn-success" (click)="performSearch()" i18n="@@SearchForButton">
        Search for Tankmix Results
      </button>
      <button class="btn btn-primary" (click)="resetSearch()" i18n="@@ResetButton">Reset</button>
    </div>
  </form>

  <div *ngIf="searching" i18n="@@Searching ......">Searching ......</div>
  <!-- <form *ngIf="!searching" [formGroup]="searchForm">
    <div class="sideBySide">
      <div>
        <div *ngIf="countryChoices" class="form-group">
          <label for="countryDropDown" i18n="@@Select your country">Select your country</label>
          <select id="countryDropDown" required name="countryDropDown" formControlName="countryCode"
            autocomplete="country-name" (change)="changeCountry()">
            <option *ngFor="let choice of countryChoices" [value]="choice.id">
              {{ choice.name }}
            </option>
          </select>
          <small *ngIf="!countryChosen" class="form-text textmuted error" i18n="@@Required">Required</small>
        </div>
        <div class="form-group">
          <label for="yaraChemicalId" i18n="@@Choose a Yara Product (optional)">Choose a Yara Product (optional)
          </label>

          <app-nameid-typeahead [items]="yaraProductChoices" id="yaraChemicalId"
            formControlName="yaraChemicalId"></app-nameid-typeahead>
          <small class="form-text textmuted"> </small>
        </div>
      </div>
    
     
        <div class="form-group">
          <label i18n="@@ProductAgro">Yara Product or Agrochemical</label>
          <app-nameid-typeahead [items]="agrochemicalChoices" id="agrochemicalCode"
            formControlName="agrochemicalCode"></app-nameid-typeahead>
          <small class="form-text textmuted"> </small>
        </div>
        <div class="form-group">
          <label for="activeIngredientDropDown" i18n="@@Choose an Active Ingredient (optional)">Choose an Active
            Ingredient (optional)
          </label>
          <app-nameid-typeahead [items]="activeIngredientChoices"
            formControlName="activeIngredientCode"></app-nameid-typeahead>
          <small class="form-text textmuted"> </small>
        </div>
      
    </div>
    <br />
    <div *ngIf="countryChosen">
      <button id="searchForTankmixes" class="btn  btn-success" (click)="performSearch()" i18n="@@SearchForButton">
        Search for Tankmix Results
      </button>
      <button class="btn  btn-primary" (click)="resetSearch()" i18n="@@ResetButton">
        Reset
      </button>
    </div>
  </form>
  <div *ngIf="searching" i18n="@@Searching ......">Searching ......</div> -->
</div>

<div *ngIf="results">
  <h3>
    <span id="numberOfResults">{{ results.length }}</span> &nbsp;
    <span i18n="@@Search Results">Search Results</span>
  </h3>
  <div *ngIf="!results.length" class="alert alert-info">
    <p i18n="@@NoTankmixResults">
      No Tankmix results were found. You may adjust your criteria, or you
      can ask one of our chemist to carry out a new test for you.
    </p>

    <a routerLink="/request">
      <button class="btn" i18n="@@requestchemicalanalysis">Request Chemical Analysis</button></a>
  </div>
  <div *ngIf="results.length == maxLimit" class="alert alert-info">
    <p i18n="@@MaxResultsReached">
      The maximum allowed number of search results were reached. You may which
      to refine your search criteria further
    </p>
  </div>
  <button class="btn" (click)="searchAgain()" i18n="@@adjustsearchcriteria">
    Adjust Search Criteria
  </button>
  <app-units-chooser></app-units-chooser>
  <div class="fullSearchResults" *ngIf="results.length">
    <table class="table-yara">
      <thead>
        <tr>
          <th i18n="@@Date Tested">Date Tested</th>
           <th class="smallColumn" i18n="@@Water Volume">Water Volume</th>
           <th i18n="@@Products">Products</th>
           <th class="smallColumn" i18n="@@Result">Result</th>
           <th class="smallColumn" i18n="@@Download Report">Download Report</th>
       
        </tr>
      </thead>
      <tbody>
        <tr class="tankmixResultRow" *ngFor="let tankmix of limitedResults">
          <td>{{ tankmix.dateOfTest | date }}</td>
          
          <td>{{ convertedWaterRate( tankmix.waterRate) | number:'1.1-1' }}</td>
          
          <td class="ingredientTableCell">
            <table class="ingredientTable">
              <thead>
                <tr>
                  <th class="numberColumn" i18n="@@Order">Order</th>
                  <th class="numberColumn" i18n="@@ApplicationRate">Rate</th>
                  <th class="ingredientname" i18n="@@Name">Name</th>
                  <th class="actives" i18n="@@Actives">Actives</th>
                  <th class="manufacturerColumn" i18n="@@Manufacturer">Manufacturer</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let ingredient of tankmix.ingredients">
                  <td>{{ ingredient.orderOfAddition }}</td>
                  <td>
                    <span *ngIf="ingredient.form!='P'">{{ convertedAppRate(ingredient.rate) | number:'1.2-2'}}</span> 
                    <span *ngIf="ingredient.form=='P'">{{convertPowderUnits(ingredient.rate)}}</span> 
                  </td>
                  <td class="ingredientName">
                    <span *ngIf="!ingredient.products">{{ingredient.name}}</span>
                    <div *ngIf="ingredient.products">
                      <span *ngFor="let product of ingredient.products">{{ product }},
                      </span>
                    </div>
                  </td>
                  <td class="actives">
                    <span *ngFor="let active of ingredient.activeIngredients">{{ active }},
                    </span>
                  </td>
                  <td>{{ ingredient.manufacturer }}</td>
                </tr>
              </tbody>
            </table>
            <span *ngIf="tankmix.observations">{{ tankmix.observations }}</span>
            <span class="phrase">{{ tankmix.phrase }}</span>
          </td>
          <td>
            <app-result-icon [value]="tankmix.result!='NC'"></app-result-icon>
          </td>
          <td routerLink="testResult/{{ tankmix.tankmixId }}/{{ languageCode }}" i18n-title="@@Download Report"
          title="Download report">
          <app-pdf-icon></app-pdf-icon>
        </td>
        </tr>
      </tbody>
    </table>
    <div promptWhenVisible (visible)="addMoreSearchResults()"></div>
  </div>

  <div class="reducedSearchResults" *ngIf="results.length">
    <div class="test" *ngFor="let tankmix of limitedResults">
      <div class="mobile-top">
        <table class="two-column">
          <tr>
            <th i18n="@@Date Tested">Date Tested</th>
            <td>{{ tankmix.dateOfTest | date }}</td>
          </tr>
          <tr>
            <th i18n="@@Water Volume">Water Volume</th>
            <td>
              {{ convertedWaterRate( tankmix.waterRate) | number:'1.1-1' }}

            </td>
          </tr>
          <tr>
            <th i18n="@@Result">Result</th>
            <td>
              <span class="phrase">{{ tankmix.phrase }}</span>
            </td>
          </tr>
          <tr *ngIf="tankmix.observations">
            <th i18n="@@Observations">Observations</th>
            <td>{{ tankmix.observations }}</td>
          </tr>
        </table>
        <div>
          <app-pdf-icon scale="1.1" routerLink="testResult/{{ tankmix.tankmixId }}/{{ languageCode }}"></app-pdf-icon>
          <app-result-icon scale="1.1" [value]="tankmix.result!='NC'"></app-result-icon>
        </div>
      </div>
      <h4>Products</h4>
      <table class="ingredientTable">
        <thead>
          <tr>
            <th class="numberColumn" i18n="@@Order">Order</th>
            <th class="numberColumn" i18n="@@ApplicationRate">Rate</th>
           <!-- <th class="manufacturerColumn">Manufacturer</th> -->
            <th colspan="2" i18n="@@Name">Name</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let ingredient of tankmix.ingredients">
            <td>{{ ingredient.orderOfAddition }}</td>
            <td>

              <span *ngIf="ingredient.form!='P'">{{ convertedAppRate(ingredient.rate) | number:'1.2-2'}}</span> 
              <span *ngIf="ingredient.form=='P'">{{convertPowderUnits(ingredient.rate)}}</span> 
        

            </td>
            <td>{{ ingredient.manufacturer }}</td>
            <td>
              <span *ngIf="!ingredient.products">{{ ingredient.name }}</span>
              <div *ngIf="ingredient.products">
                <span *ngFor="let product of ingredient.products">{{ product }},
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div promptWhenVisible (visible)="addMoreSearchResults()"></div>
  </div>
  
</div>
